exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".story{background-color:#fff;background-image:-webkit-linear-gradient(top,#fff,#efefef,#fefefe,#fefefe,#fefefe,#fff);background-image:-moz-linear-gradient(top,#fff,#efefef,#fefefe,#fefefe,#fefefe,#fff);background-image:-o-linear-gradient(top,#fff,#efefef,#fefefe,#fefefe,#fefefe,#fff);background-image:linear-gradient(180deg,#fefefe,#efefef,#fefefe,#fefefe,#fefefe,#fff)}.story-name{padding:15px 20px}.delimiter{padding-top:50px}.content{font-size:.9rem}pre.settings{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64ff7eb0","scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Story.vue
// module id = 86
// module chunks = 0